"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/components/RevokeAPIKeyModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _noticeBar = require('web/services/context/noticeBar');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);








const RevokeAPIKeyModal = ({ isOpen, onClose, apiKey, onProceed }) => {
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const onSubmit = () => {
    setIsLoading(true)
    onProceed()
      .then(() => showSuccessBar(`Revoked "${apiKey.Name}".`))
      .then(onClose)
      .catch(() => showWarningBar('Failed to revoke the API key.'))
      .finally(() => setIsLoading(false))
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: `Revoke "${apiKey.Name}"?`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "Apps using it stop working immediately."     )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnTheme: "danger",
        primaryBtnLabel: "Revoke",
        isPrimaryLoading: isLoading,
        onPrimaryBtnClick: onSubmit,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      )
    )
  )
}

exports. default = RevokeAPIKeyModal
